<template>
  <div style="margin-top:1px;">
    <div style="padding:5px; background:rgba(240,242,242,0.8);">
      Kalendar PHO/FHO
    </div>
    <div
      style="background:white; font-size: 14px; height: calc(100vh - 155px); overflow:auto;"
    >
      <div v-for="(item, idx) in items" :key="idx">
        <div
          style="background-color:#333; color:white; padding:10px;"
          v-if="idx == 0 || item.TglFHO != items[idx - 1].TglFHO"
        >
          {{ item.TglFHO | format }}
        </div>
        <div style="padding:10px; border-bottom:1px solid #ddd;">
          <div color="#1976d2">
            [{{
              item.TglFHO == item.TglSelesai
                ? 'PHO'
                : item.TglFHO == item.TglPemeliharaan
                ? 'FHO'
                : 'INS'
            }}]
            {{ item.NamaPaket }}
          </div>
          <div style="color:gray">{{ item.NamaBalai }}</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data: () => ({
    items: [],
    tahun: localStorage.getItem('tahun'),
    balaiId: localStorage.getItem('balaiId'),
  }),
  computed: {
    currentYear() {
      return new Date().getFullYear()
    },
  },
  mounted() {
    this.populate()
  },
  methods: {
    async populate() {
      let res = await this.$api.call('DOC_SelFHO')
      this.items = res.data
    },
  },
}
</script>
